export default "__VITE_ASSET__2cYSFqU5__"